import * as buttons from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import { Phone } from 'smg/phone';
import { Uploader } from 'smg/uploader/v2';

void main();

async function main() {
    const name = document.querySelector('#name') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const message = document.querySelector('#message') as HTMLTextAreaElement;
    const form = document.querySelector('#contact-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;
    const cardBody = form.closest('.card-body') as HTMLElement;

    const sess = await Session().catch(() => undefined);
    if (sess) {
        name.value = sess.user.fullName();
        email.value = sess.user.emailAddress.email || '';
        phone.value = sess.user.phoneNumber.phone || '';
    }

    const p = new Phone(phone);

    const u = new Uploader({
        $input: uploadsLabel.querySelector('input[type="file"]') as HTMLInputElement,
        $dropzones: [uploadsLabel],
        $submitButtons: [confirm],
        $thumbnailsParent: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form.addEventListener('submit', async e => {
        e.preventDefault();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);
        CreateContact({
            name: name.value,
            company: '',
            phone: p,
            email: email.value,
            content: message.value,
            // allowPartial: the message is the payload; failed attachments were already surfaced
            uploadIDs: await u.uploadIDs({ allowPartial: true }),
            $reCaptchaPlaceholder: document.querySelector('.contact-recaptcha-parent') as HTMLElement,
        }).then(() => {
            cardBody.innerHTML = `
                <div class="text-center py-5">
                    <i class="fas fa-check-circle fa-3x text-success mb-3"></i>
                    <h3>Thank you for reaching out!</h3>
                    <p class="text-muted">We will get back to you within 1 business day.</p>
                </div>
            `;
        }).catch(err => {
            console.error(err);
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);
        });
    });
}
